<template>
  <section class="app-financeiro">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title">Validação de Certidão Negativa</v-card-title>
            <v-card-text class="app-card-content">
              <v-row v-if="certificate">
                <v-col :md="6" :sm="6" :xs="12" cols="12">
                  <v-text-field
                    v-if="certificate.numCertidao"
                    v-model="certificate.numCertidao"
                    label="Número Certidão *"
                    disabled
                    filled
                    rounded
                    dense
                  ></v-text-field>
                </v-col>
                <v-col :md="6" :sm="6" :xs="12" cols="12">
                  <v-text-field
                    v-if="certificate.dataValidadeStr"
                    v-model="certificate.dataValidadeStr"
                    label="Validade *"
                    disabled
                    filled
                    rounded
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>

              <section class="text-center" v-if="isLoading">
                <v-progress-circular class="d-block mt-auto mr-auto ml-auto mb-2" color="blue darken-2" indeterminate :size="40"></v-progress-circular>
                <p class="font-weight-medium">Aguarde! Validando informacões ...</p>
              </section>

              <v-alert :type="notify.type" v-if="notify.show">
                {{notify.message}}
              </v-alert>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import CertidaoNegativaService from "@/services/financeiro/certidao-negativa.service"
import dayjs from "dayjs";

export default {
  metaInfo: {
    title: "Validar Certidão Negativa - Financeiro - Central de Serviços"
  },

  data: () => ({
    token: null,
    cpfCnpj: null,
    notify: {
      show: false,
      type: null,
      message: null
    },
    isLoading: false,
    certificate: null,
  }),

  mounted() {
    this.checkParams()
  },

  methods: {
    checkParams() {
      this.isLoading = true

      this.token = this.$route.query.token
      this.cpfCnpj = this.$route.query.cpfcnpj

      if(!this.token){
        const message =  "Token não informado"
        this.notify = { show: true, type: "error", message: message }
        this.isLoading = false
        throw message
      }

      if(!this.cpfCnpj){
        const message = "CPF/CNPJ não informado"
        this.isLoading = false
        this.notify = { show: true, type: "error", message: message }
        throw message
      }

      this.getCertificate()
    },

    getCertificate() {
      CertidaoNegativaService
        .findByCpfCnpj(this.token, this.cpfCnpj)
        .subscribe(res=>{
          this.isLoading = false
          this.certificate = res

          this.checkToken()
          this.checkValidate()
        }, err => {
          const { response } = err;
          const { data } = response;

          let message = data.message || data.mensagem  || data.error || "Ocorreu uma falha ao processar a requisição";

          this.isLoading = false
          this.notify = {
            show: true,
            type: "error",
            message: message
          }
        })
    },

    checkToken() {
      const { id } = this.certificate

      if(id!==this.token) {
        const message = "O token informado é diferente do token da certidão"

        this.notify = {
          show: true,
          type: "error",
          message: message
        }

        throw message
      }
    },

    checkValidate() {
      const { dataValidade } = this.certificate

      if(dayjs().isBefore(dayjs(dataValidade))) {
        this.notify = {
          message: "Essa certidão está valida",
          show: true,
          type: "success"
        }

        return;
      }

      const message = "Essa certidão já está expirada"

      this.notify = {
        message: message,
        show: true,
        type: "error"
      }

      throw message
    },

    reset() {
      this.token = null
      this.cpfCnpj = null
      this.notify = {
        show: false,
        type: null,
        message: null
      }
      this.isLoading = false
      this.certificate = null
    }

  }
};
</script>

